import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { FixedPriceShellComponent } from '../fixed-price/containers/fixed-price-shell/fixed-price-shell.component';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from './process-resolver';

const log = new LoggingService();
export const FixedPriceRoute: Ng2StateDeclaration = {
    name: 'manualtxnexpense',
    url: '/manualtxnexpense',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: FixedPriceShellComponent
};
